<div class="search-container">
  <form class="form-search-bar" [formGroup]="searchForm" (ngSubmit)="handleSubmit()">

    <mat-form-field appearance="outline">
      <mat-label>Categories</mat-label>
      <mat-select [formControl]="categoriesControl" multiple disableOptionCentering>
        <mat-option *ngFor="let category of categories" [value]="category">{{category}}</mat-option>
      </mat-select>
    </mat-form-field>

    <button type="button" mat-raised-button (click)="clean()">Clean</button>
    <button type="submit" mat-raised-button color="primary">Apply</button>
    <app-zoom-help></app-zoom-help>
    <app-new-tab-button></app-new-tab-button>

  </form>
</div>
